export function drawCompareChart(containerId, compareList) {
  MST.SvgChart.setTimeFormatFunction( SW.ChartIntegration.formatTime );
  MST.SvgChart.setNumberFormatFunction( SW.ChartIntegration.formatNumber );
  MST.SvgChart.setTranslateFunction( SW.ChartIntegration.translateString );

  var chart = document.getElementById(containerId);
  // remove all childnodes
  while(chart.hasChildNodes())
  {
      chart.removeChild(chart.firstChild);
  }

  var myChart = new MST.SvgChart(chart);
  var benchmarks = {
      ".N225": {id: ".N225", name: "日経平均", type: "index", index: 0},
      ".TOPX": {id: ".TOPX", name: "TOPIX",   type: "index", index: 1},
      ".DJI":  {id: ".DJI",  name: "ダウ",    type: "index", index: 2},
//        "11":    {id: "11", name: "金",  type: "futures", index: 3},
//        "33":    {id: "33", name: "原油", type: "futures", index: 4},
////        "81":    {id: "81", name: "ゴム", type: "futures", index: 5},
      // New code
      "2TCE01":    {id: "2TCE01", name: "金",  type: "futures", index: 3},
      "2TCE12":    {id: "2TCE12", name: "原油", type: "futures", index: 4},
      "JPY=X": {id: "JPY=X", name : "米ドル/円", type: "futures", index: 5},
  };

  for(var i = 0; i < compareList.length; i++){
      var type = "fund";

      if(i == 0) type = "default";

      benchmarks[compareList[i][0]] = {id: compareList[i][0],
          name: compareList[i][1], type: type, index: i + 6};
  }

  myChart.colorSelectList = {};
  myChart.setLanguage('jp');
  myChart.setBenchmarks(benchmarks);


//   MST.BENCHMARK_LIMIT = 5

  myChart.setParams(compareList[0][0], compareList[0][1], 'TYO', {
          controller: {timeFrame : '1Y', showController : true, showIndicator: false, showBenchmark: true,
              showUpdateBrowser: true, showChartRange: true, showType: true, showReset: false,
              ranges : ["3M", "6M", "1Y", "3Y", "5Y", "10Y", "ALL"]},
          scroll: {showScroll: true},
          technicalList : [['line']]
      }
  );

  for(var i = 1; i < compareList.length; i++){
      myChart.addBenchmark(compareList[i][0], i);
  }
  
  $('#chart_comment').removeClass('hide');

  document.addEventListener("click", function(e){
      e = e || window.event;
      var target = e.target || e.srcElement;
      if(e.button == 0 && target.className != "SvgChartIndicatorControllerView"){
          myChart.closeMenu();
      }
  });
}

window.drawCompareChart = drawCompareChart

export default drawCompareChart;
